export default __webpack_public_path__ + "static/media/landing-bg-tablet.a0e40464.jpg";